export const phnnumber: number = 8146919479;
export const email: string = 'harielectricworks@yahoo.in';
export const address: string = 'Industrial Area Uchi Mangali, Mithai factory road, backside Aarti International, Chandigarh Road, Ludhiana (Punjab)';
export const companyName: string = 'HARI Electrical Works';
export const noOfYear: number = new Date().getFullYear() - 2006

export const mainURL: string = 'https://harielectricalworks.com'